import styled from 'styled-components/macro';
import { colors, Input } from '@twnel/web-components';

const DEFAULT_PADDING = 16;
const ICON_SIZE = 8;
const LEVEL_SPACE = 16;

export const Wrapper = styled.div`
  display: flex;
  position: relative;
`;

export const Bar = styled.div`
  position: absolute;
  height: 2rem;
  top: 100%;
  right: 0;
  background: #${colors.darkGray};
  border-radius: 4px;
  display: ${(props) => (props.displayItem ? 'flex' : 'none')};
  box-sizing: border-box;
  overflow: hidden;
  z-index: 10;
`;

export const Option = styled.div`
  display: flex;
  height: 100%;
  font-weight: 900;
  align-items: center;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  background: #${colors.darkGray};
  color: #${(props) => (props.isActive ? colors.blue : colors.textLight)};
  cursor: pointer;
  &:hover {
    background: #${colors.textLight};
    color: #${colors.white};
  }
`;

export const OptionPanel = styled.div`
  position: absolute;
  top: calc(100% + 2rem);
  width: 359px;
  height: 246px;
  border-radius: 5px;
  right: 0;
  display: ${(props) => (props.displayItem ? 'flex' : 'none')};
  border: 1px solid #${colors.gray};
  background: #${colors.white};
  z-index: 2000;
  div, input {
    outline: none !important;
    width: 100%;
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  overflow-y: auto;
`;

export const TestDiv = styled.div`
  display: inline-block;
`;

export const ItemWrapper = styled.li`
  padding: .75rem 1.25rem;
  padding-left: ${(props) => DEFAULT_PADDING + ICON_SIZE + props.level * LEVEL_SPACE}px;
  z-index: ${(props) => (props.focused ? 999 : 'unset')};
  margin-top: 0;
  position: relative;
  border-bottom: 1px solid #${colors.gray};
  color: #${colors.textBlack};
  &:hover {
    background: #${colors.darkGray};
  }
`;

export const Chevron = styled.div`
  display:flex;
  width: auto !important;
  margin-right: 8px;
  font-size: 0.8rem;
  transition: transform 0.6s ease;
  cursor: pointer;

  &.rotate {
    transform: rotate(90deg);
  }
`;

export const TreeWrapper = styled.div`
  overflow-y: auto;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
`;
